import InputField from './InputField';
import Button from './button';
import React from 'react';
import unhiding from '../../resources/imgs/Eye_Icon.png';
import copy from '../../resources/imgs/Colorful_Copy_Icon.png';
import { CredentialInfo } from 'types/credential-info';



const togglePassword = (event: React.MouseEvent<HTMLButtonElement>) => {
  const button = event.target as HTMLButtonElement;
  const passwordField = button.closest('.flex-item')?.querySelector('input[type="password"], input[type="text"]') as HTMLInputElement;

  if (passwordField) {
    if (event.type === "mousedown" || event.type == "click") {
      passwordField.type = "text";
    } else if (event.type === "mouseup" || event.type === "mouseleave") {
      passwordField.type = "password";
    }
  }
};


const copyPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
  const button = event.target as HTMLButtonElement;
  const passwordField = button.closest('.flex-item')?.querySelector('input[type="password"], input[type="text"]') as HTMLInputElement;

  if (passwordField) {
    const copied = `${passwordField.name} copied to clipboard`;
    const notCopied = `Failed to copy ${passwordField.name}`;

    passwordField.select();
    passwordField.setSelectionRange(0, 99999);

    navigator.clipboard.writeText(passwordField.value).then(() => {
      alert(copied);
    }, () => {
      alert(notCopied);
    });
  }
};



interface dataProps{
    data : CredentialInfo
}



const CredentialPieces :React.FC<dataProps> = ({data}) =>{
    console.log(copy);
 



return(

    

<div className='flex-item'>
 <InputField label={data.label} 

 id={data.id}

 value={data.value} />


 <Button
 onMouseDown={(event) => togglePassword(event)}
 onMouseLeave={(event) => togglePassword(event)}
 onMouseUp={(event) => togglePassword(event)}
 onClick={togglePassword}



//src="../../resources/img/Eye_Icon.png"
 src={unhiding}

 alt="Unhide Key Input"
 />

 <Button
 onClick={copyPassword}
//src="../../resources/img/Colorful_Copy_Icon.png"
 src={copy}

 alt="Copy Key to Clipboard"
 />

 </div>)};

 export default CredentialPieces;